import { render, staticRenderFns } from "./tax-profile-edit-modal.vue?vue&type=template&id=5237e322&scoped=true&"
import script from "./tax-profile-edit-modal.vue?vue&type=script&lang=js&"
export * from "./tax-profile-edit-modal.vue?vue&type=script&lang=js&"
import style0 from "./tax-profile-edit-modal.vue?vue&type=style&index=0&id=5237e322&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5237e322",
  null
  
)

export default component.exports